import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo-light.svg'
import _imports_1 from '@/assets/images/icon-illumina-basespace.png'


const _hoisted_1 = { id: "landing-page" }

import { login } from '@/auth/keycloak';


export default /*@__PURE__*/_defineComponent({
  __name: 'LandingPageView',
  setup(__props) {

function enterAnalytics() {
  login();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { id: "landing-content" }, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_0,
        class: "logo mt-3",
        alt: "Sampling Human"
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("button", {
        class: "btn enter",
        onClick: enterAnalytics
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "fa fa-line-chart" }, null, -1),
        _createTextVNode(" Enter Analytics Cloud ", -1)
      ]))]),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "links" }, [
        _createTextVNode(" or go to "),
        _createElementVNode("a", {
          href: "https://samplinghuman.com",
          class: "user"
        }, "samplinghuman.com")
      ], -1))
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", {
      id: "compliance-content",
      class: "d-flex flex-wrap justify-content-center"
    }, [
      _createElementVNode("img", {
        src: _imports_1,
        alt: "Illumina BaseSpace Sequence Hub Integration"
      })
    ], -1))
  ]))
}
}

})